// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2P7bN","image":"Header_image__3vxri","name":"Header_name__hBGrA","info":"Header_info__2bhj3","infoRow":"Header_infoRow__uhN1C"};